import { Button } from '@/ui-kit'
import CheckBox from '@/ui-kit/components/Checkbox'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useState } from 'react'
import { toast } from 'sonner'
import { useEnrollInProject } from '../api'

export const EnrollmentContent = ({
  projectId,
  rules,
  disabled
}: {
  projectId: string
  rules: string
  disabled: boolean
}) => {
  const { mutate: enroll, isPending: isEnrolling } = useEnrollInProject()
  const [rulesAccepted, setRulesAccepted] = useState(false)

  const handleEnroll = () => {
    enroll(
      { projectId: projectId, acceptRules: rulesAccepted ? true : undefined },
      {
        onError: () => {
          toast.error(t`Failed to enroll in project`)
        }
      }
    )
  }

  const canEnroll = !rules || rulesAccepted

  return (
    <div className="flex flex-col gap-4">
      {rules && (
        <div className="flex flex-col gap-4">
          <div className="text-gray-80 leading-7 whitespace-pre-wrap">{rules}</div>
        </div>
      )}
      <div className="flex flex-col gap-5 border-t border-gray-100 pt-5">
        <div className="text-gray-80">
          <Trans>
            By participating, you agree that your recordings may be used worldwide and indefinitely for AI training and
            synthetic voice technologies.
          </Trans>
        </div>
        <CheckBox
          disabled={disabled}
          defaultChecked={rulesAccepted}
          onChange={(value) => setRulesAccepted(Boolean(value))}
          className="text-gray-80"
          label={t`Accept mission rules`}
        />
        <Button
          size="small"
          className="wizard-cta-button max-mobile:w-full max-mobile:max-w-full text-white-to-black max-w-max"
          onClick={handleEnroll}
          isDisabled={disabled || !canEnroll || isEnrolling}
        >
          {isEnrolling ? t`Enrolling...` : t`Start Mission`}
        </Button>
      </div>
    </div>
  )
}
